import { appLink } from '@app/config/appLink'
import { ProtectedRoute } from '@app/Auth/ProtectedRoute'
import { FEATURE_FLAGS } from '@app/app-constants'
import { FeatureFlagGate } from '@app/FeatureFlag/FeatureFlagGate'
import { UnauthorizedPage } from '@app/routes/UnauthorisedPage/UnauthorizedPage'
import PropertyLayout from '@app/layout/PropertyLayout'
import { PropertyLandingPage } from '@app/components/Property/components/PropertyLandingPage'
import { AccessLandingPage } from '@app/routes/AccessPage'
import { AdaptationPage } from '@app/routes/AdaptationPage'
import { AdminLayout } from '@app/modules/Admin/layouts/Admin.layout'
import ManageUsersPage from '@app/modules/Admin/pages/Admin.page'
import { FeatureFlagsPage } from '@app/modules/Admin/pages/FeatureFlagsPage'
import { OnboardingPage } from '@app/routes/OnboardingPage'
import { PropertyPage } from '@app/routes/PropertyPage'
import { ErrorPage } from '@app/routes/ErrorPage'
import { Navigate, Outlet, Route } from 'react-router-dom'
import { LayerPermissionsPage } from '@app/modules/Admin/pages/Admin.layerPermissions'
import SmokeTestShadCn from '@app/SmokeTestShadCn'
import { RexLivePage } from '@app/modules/Live/Live.page'
import RiskProfilePage from '@app/modules/Risk/Profile/pages/risk-profile.page'
import WorkspacesDialog from '@app/components/Risk/Workspaces/WorkspacesDialog'
import WorkspacesManager from '@app/components/Risk/Workspaces/WorkspacesManager'
import WorkspacesCreate from '@app/components/Risk/Workspaces/WorkspacesCreate'
import { WorkspaceEdit } from '@app/components/Risk/Workspaces/WorkspaceEdit'
import LiveLayout from '@app/modules/Live/Live.layout'

export default function AppRoutes() {
  return (
    <>
      <Route
        path="smoke"
        element={
          <FeatureFlagGate
            flag={FEATURE_FLAGS.SHADCN_UI}
            fallback={<UnauthorizedPage feature={appLink.smokeShadCn.featureFlag} />}
          >
            <SmokeTestShadCn />
          </FeatureFlagGate>
        }
      />
      <Route path="property" element={<Navigate to="property/search" replace />} />
      <Route
        path="property/search"
        element={
          <FeatureFlagGate
            flag={FEATURE_FLAGS.PROPERTY_PAGE}
            fallback={<UnauthorizedPage feature={appLink.property.featureFlag} />}
          >
            <ProtectedRoute>
              <PropertyLayout>
                <PropertyLandingPage />
              </PropertyLayout>
            </ProtectedRoute>
          </FeatureFlagGate>
        }
      />
      <Route
        path="property/:id"
        element={
          <ProtectedRoute>
            <PropertyPage />
            <Outlet />
          </ProtectedRoute>
        }
      />

      <Route path={appLink.access.path} element={<AccessLandingPage />} />
      <Route
        path="adaptation"
        element={
          <ProtectedRoute>
            <AdaptationPage />
          </ProtectedRoute>
        }
      />
      <Route path="onboarding" element={<OnboardingPage />} />

      <Route
        path="admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="manage-users" replace />} />
        <Route path="manage-users" element={<ManageUsersPage />} />
        <Route path="feature-flags" element={<FeatureFlagsPage />} />
        <Route path="layer-permissions" element={<LayerPermissionsPage />} />
      </Route>

      <Route path="unauthorized" element={<UnauthorizedPage />} />
      <Route path="*" element={<ErrorPage />} />

      <Route
        path={appLink.rexLive.path}
        element={
          <FeatureFlagGate
            flag={FEATURE_FLAGS.REX_LIVE}
            fallback={<UnauthorizedPage feature={appLink.rexLive.featureFlag} />}
          >
            <ProtectedRoute>
              <LiveLayout>
                <RexLivePage />
              </LiveLayout>
            </ProtectedRoute>
          </FeatureFlagGate>
        }
      >
        <Route path="workspaces" element={<WorkspacesDialog />}>
          <Route path="saved" element={<WorkspacesManager />} />
          <Route path="create" element={<WorkspacesCreate />} />
          <Route path=":workspaceId/edit" element={<WorkspaceEdit />} />
        </Route>
      </Route>
    </>
  )
}
